// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"8d79a92f","365":"4f880bbe","384":"c645600b","403":"2e310b48","433":"b72af58f","439":"7ff2c8e6","453":"28106ac9","610":"d95d54b8","725":"a13147bb","749":"ae47b082","903":"bbf8e926","954":"d1e5f430","976":"e604e2b1"}[chunkId] + ".chunk.js";
};